import React from "react";
import { Box, Typography, IconButton, Link, Container } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { useAppConfig } from "../context/AppConfigContext";

const SharedBanner = ({ onClose }) => {
  const { config } = useAppConfig();
  const banner = config?.globalBanner;

  if (!banner?.enabled) return null;

  const now = dayjs();
  const showUntil = dayjs(banner.showUntil);
  if (!showUntil.isValid() || now.isAfter(showUntil)) return null;

  return (
    <Box
      sx={{
        backgroundColor: banner.backgroundColor || "#FFF8E1",
        color: banner.textColor || "#000",
        py: 2,
        display: "flex",
        justifyContent: "center",
      }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "center", sm: "center" },
            justifyContent: { xs: "center", sm: "center" },
            textAlign: { xs: "center", sm: "left" },
            gap: 1,
            flexWrap: "wrap",
          }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexWrap: "wrap",
              justifyContent: "center",
            }}>
            <Typography
              variant="body2"
              sx={{ fontSize: "0.95rem", color: banner.textColor || "#000" }}>
              {banner.icon && `${banner.icon} `}
              {banner.message}
            </Typography>

            {onClose && (
              <Box sx={{ display: { xs: "none", sm: "block" } }}>
                <IconButton
                  size="small"
                  onClick={onClose}
                  sx={{ color: "inherit" }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </Box>

          {onClose && (
            <Box sx={{ display: { xs: "block", sm: "none" } }}>
              <Link
                component="button"
                onClick={onClose}
                underline="always"
                color="inherit"
                sx={{ fontSize: "0.85rem" }}>
                Close
              </Link>
            </Box>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default SharedBanner;
